import { http } from '@/lib/http';
import type { Invoice, InvoicePrintable, InvoiceStatus } from '@/types/invoices';

const BASE = '/api/v1/invoices';
const ORDERS = '/api/v1/orders';

export interface InvoiceListQuery {
  status?: InvoiceStatus;
  salesOrderId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface InvoiceListResponse {
  rows: Invoice[];
  page: number;
  pageSize: number;
  total: number;
}

export interface GenerateInvoicePayload {
  salesOrderId: string;
  invoiceDate?: string;
  dueDate?: string;
  billingAddressId?: string;
  shippingAddressId?: string;
  notes?: string;
  terms?: string;
}

export const invoicesService = {
  list: (query: InvoiceListQuery = {}) =>
    http.get<InvoiceListResponse>(BASE, { params: query }),
  get: (id: string) => http.get<Invoice>(`${BASE}/${id}`),
  generate: (payload: GenerateInvoicePayload) =>
    http.post<Invoice, GenerateInvoicePayload>(BASE, payload),
  cancel: (id: string, reason?: string) =>
    http.patch<Invoice, { reason?: string }>(`${BASE}/${id}/cancel`, { reason }),
  print: (id: string) => http.get<InvoicePrintable>(`${BASE}/${id}/print`),
  /** Order-scoped lookup — drives the in-order Invoices tab. */
  listForOrder: (orderId: string) => http.get<Invoice[]>(`${ORDERS}/${orderId}/invoices`),
};
